class CleverReachForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.messageError = this.querySelector('[data-cr-error]');
    this.messageSuccess = this.querySelector('[data-cr-success]');
    this.button = this.querySelector('[data-cr-submit]');
    this.buttonLabel = this.button ? this.button.textContent.trim() : '';

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  async onSubmit(event) {
    // Ohne JS bleibt das native Absenden via target="_blank" als Fallback aktiv.
    event.preventDefault();

    this.setBusy(true);
    this.hide(this.messageError);

    try {
      const response = await fetch(this.form.action, {
        method: 'POST',
        body: new URLSearchParams(new FormData(this.form)),
        headers: { Accept: 'text/html' },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      this.showSuccess();
    } catch (error) {
      console.error('[CleverReach] Anmeldung fehlgeschlagen:', error);
      this.show(this.messageError);
      this.setBusy(false);
    }
  }

  showSuccess() {
    const fields = this.querySelector('[data-cr-fields]');
    if (fields) fields.setAttribute('hidden', '');
    this.show(this.messageSuccess);
    if (this.messageSuccess) this.messageSuccess.focus();
  }

  setBusy(isBusy) {
    if (!this.button) return;
    this.button.disabled = isBusy;
    this.button.classList.toggle('loading', isBusy);
  }

  show(element) {
    if (element) element.removeAttribute('hidden');
  }

  hide(element) {
    if (element) element.setAttribute('hidden', '');
  }
}

customElements.define('cleverreach-form', CleverReachForm);
